import type { ChordProLine } from './types';

export const CHORD_KEYS = ['C', 'Db', 'D', 'Eb', 'E', 'F', 'Gb', 'G', 'Ab', 'A', 'Bb', 'B'] as const;
const SHARP_KEYS = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];
const FLAT_KEYS = [...CHORD_KEYS];
const NOTE_INDEX: Record<string, number> = {
  C: 0, 'B#': 0, 'C#': 1, Db: 1, D: 2, 'D#': 3, Eb: 3, E: 4, Fb: 4,
  'E#': 5, F: 5, 'F#': 6, Gb: 6, G: 7, 'G#': 8, Ab: 8, A: 9,
  'A#': 10, Bb: 10, B: 11, Cb: 11,
};

export const semitoneDistance = (from: string, to: string): number => {
  const start = NOTE_INDEX[from];
  const end = NOTE_INDEX[to];
  return start === undefined || end === undefined ? 0 : (end - start + 12) % 12;
};

export const transposeChord = (chord: string, semitones: number, preferFlats = true): string => {
  const notes = preferFlats ? FLAT_KEYS : SHARP_KEYS;
  return chord.replace(/(^|[/(])([A-G](?:#|b)?)/g, (full, prefix: string, note: string) => {
    const index = NOTE_INDEX[note];
    if (index === undefined) return full;
    return `${prefix}${notes[(index + semitones + 120) % 12]}`;
  });
};

export const transposeLine = (line: ChordProLine, semitones: number, preferFlats = true): ChordProLine => ({
  ...line,
  segments: line.segments.map((segment) => ({
    ...segment,
    chord: segment.chord ? transposeChord(segment.chord, semitones, preferFlats) : undefined,
  })),
});

export const transposeChordProSource = (source: string, semitones: number, preferFlats = true): string =>
  source.replace(/\[([^\]]+)]/g, (_match, chord: string) => `[${transposeChord(chord, semitones, preferFlats)}]`);
